import React, { useState, useEffect } from "react";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import {
  EditBrandByAPI,
  GetBrandById,
  GetProductStatus,
} from "../apiconfig/authService";
import { RiLoaderFill } from "react-icons/ri";
import { toast } from "react-toastify";

function EditBrand(props) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [editedEmployeeData, setEditedEmployeeData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [statusData, setStatusData] = useState([]);
  const setProductViewMessage = props.setMessage;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await GetBrandById(
          id,
          localStorage.getItem("accessToken")
        );
        setEditedEmployeeData(response.data);
      } catch (error) {
        toast.error("Failed to fetch brand data.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );

        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);


  const handleDiscardClick = () => {
    navigate("/brand");
  }

  const handleDescriptionChange = (e) => {
    setEditedEmployeeData((prevData) => ({
      ...prevData,
      brandname: e.target.value,
    }));
  };

  const handleStatusIdChange = (e) => {
    setEditedEmployeeData((prevData) => ({
      ...prevData,
      statusid: Number(e.target.value), // Update statusid in editedEmployeeData
    }));
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    if (!editedEmployeeData.brandname?.trim()) {
      toast.error("Brand Name is required");
      return;
    }

    try {
      setEditLoading(true);
      const response = await EditBrandByAPI(
        {
          id: id,
          brandname: editedEmployeeData.brandname,
          statusid: editedEmployeeData.statusid,
        },
        localStorage.getItem("accessToken")
      );
      if (response.status === 200) {
        setEditLoading(false);
        setProductViewMessage(response.data.message);
        toast.success("Brand Updated Successfully");
        navigate("/brand");
      }
    } catch (err) {
      toast.error(
        err.response?.data?.error || "An error occurred. Please try again."
      );
    } finally {
      setEditLoading(false);
    }
  };


  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Brand Name</h1>
        </div>
        {isLoading ? (
          <div className="d-flex align-items-center justify-content-center">
            <RiLoaderFill
              size={40}
              className="text-success spin-animation text-center"
            />
          </div>
        ) : (
          <form onSubmit={handleSubmitClick}>
            <div className="personal-info tab-pane active storetab mb-3">
              <div className="form-group col-sm-12 col-lg-12">
                <label htmlFor="brandName">Brand Name</label>
                <input
                  type="text"
                  onChange={handleDescriptionChange}
                  value={editedEmployeeData?.brandname || ""}
                  className="form-control custom-input my-3"
                  id="brandname"
                  placeholder="Brand Name"
                />
              </div>
              <div className="form-group col-sm-12 col-lg-12 mb-3">
                <label htmlFor="floatingInput">Status</label>
                <select
                  className="form-select custom-input my-2"
                  onChange={handleStatusIdChange}
                  value={editedEmployeeData?.statusid || ""}
                >
                  {statusData?.map((item) => (
                    <option key={item.statusid} value={item.statusid}>
                      {item.status}
                    </option>
                  ))}
                </select>
              </div>
              <div className="row">
                <div
                  className="col-12 d-flex"
                  style={{ height: "40px", width: "120px" }}
                >
                  <button
                    type="button"
                    onClick={handleDiscardClick}
                    disabled={editLoading}
                    style={{ height: "100%", width: "100%" }}
                    className="btn btn-danger save-btn text-uppercase"
                  >
                    Discard
                  </button>{" "}
                  &nbsp;
                  {editLoading ? (
                    <div
                      className="btn btn-primary loader-active save-btn"
                      style={{ height: "100%", width: "100%" }}
                    >
                      <RiLoaderFill
                        size={20}
                        className="spin-animation"
                        color="white"
                      />
                    </div>
                  ) : (
                    <button
                      type="submit"
                      onClick={handleSubmitClick}
                      disabled={editLoading}
                      className="btn btn-primary save-btn text-uppercase"
                      style={{ height: "100%", width: "100%" }}
                    >
                      Save
                    </button>
                  )}
                </div>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default EditBrand;
